import { slickCarousel } from 'slick-carousel'; // eslint-disable-line no-unused-vars

export default class Slider {
  constructor() {
    this.sliderElement = $('.js-slider');
    this.sliderPager = $('.js-slider_pager');
    this.sliderLink = $('.js-slider_link');

    if (this.sliderElement.length) {
      this.slider();
    }
  }

  slider() {
    this.sliderElement.slick({
      speed: 700,
      fade: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4500,
      slidesToShow: 1,
      slidesToScroll: 1,
      waitForAnimate: false,
      dots: true,
      arrows: false,
      appendDots: this.sliderPager,
    });
    this.sliderElement.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      const slide = $('.js-slider .series-hero-images-item').eq(nextSlide).find('.js-slide_image');
      const slideText = slide.data('slide-text');
      const slideHref = slide.data('slide-href');
      if (slideHref) {
        this.sliderLink.html(`<a href="${slideHref}">${slideText}</a>`);
      } else {
        this.sliderLink.html('');
      }
    });
  }
}
